

<app-loader></app-loader>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="custom-sidenav" [attr.role]="'navigation'"
    [mode]="isHandset ? 'over' : 'side'" [opened]="!isHandset && sideNavOpened" (closedStart)="closeSideNav()" mode="over" [opened]="true">
    <div class="sidenav-header">
      <h3 class="sidenav-title">{{ appSvc.shortTitle }}</h3>
    </div>
    <div class="sidenav-content">
      <div class="nav-item">
        <a class="nav-link" routerLink="/main" (click)="drawer.close()" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">home</mat-icon>
          <span class="nav-text">Inicio</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" (click)="showingMenuAdd = !showingMenuAdd">
          <mat-icon class="nav-icon">add</mat-icon>
          <span class="nav-text">Nuevo...</span>
        </a>
        <div *ngIf="showingMenuAdd" class="submenu">
          <a class="nav-link" (click)="drawer.close(); openFileDialog()">Fichero de solicitudes</a>
          <a class="nav-link" (click)="drawer.close()">Pago</a>
          <a class="nav-link" (click)="drawer.close(); receiveProduct()">Recepción de material</a>
        </div>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/productos" (click)="drawer.close()" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">local_offer</mat-icon>
          <span class="nav-text">Productos</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/dashboard" (click)="drawer.close()" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">bar_chart</mat-icon>
          <span class="nav-text">Dashboard</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/consultas" (click)="drawer.close()" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">pageview</mat-icon>
          <span class="nav-text">Consultas</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/facturacion" (click)="drawer.close()" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">monetization_on</mat-icon>
          <span class="nav-text">Facturación</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/pagos" (click)="drawer.close()" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">payments</mat-icon>
          <span class="nav-text">Pagos</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/almacenes" (click)="drawer.close()" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">receipt</mat-icon>
          <span class="nav-text">Almacenes</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/almacen" (click)="drawer.close()" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">receipt</mat-icon>
          <span class="nav-text">Almacén</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/usuarios-admin" (click)="drawer.close()" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">person</mat-icon>
          <span class="nav-text">Admin. Usuarios</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/clientes" (click)="drawer.close()" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">group</mat-icon>
          <span class="nav-text">Admin. Clientes</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/reports" (click)="drawer.close()" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">list_alt</mat-icon>
          <span class="nav-text">Informes</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/ws-externos" (click)="drawer.close()" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">cast</mat-icon>
          <span class="nav-text">WS Externos</span>
        </a>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar class="main-toolbar">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()" class="menu-button">
        <mat-icon>menu</mat-icon>
      </button>
      <img class="title" routerLink="/main" src="/assets/images/logo-topbar.png" />
      <span class="toolbar-title">{{ appSvc.appSubTitle }}</span>
      <div class="toolbar-spacer"></div>
      <form #formSearch [formGroup]="fSearch" class="search-form">
        <div class="search-wrapper">
          <input matInput type="text" formControlName="search" placeholder="Buscar..." class="search-input">
          <button mat-icon-button (click)="globalSearch()" class="search-button">
            <mat-icon>search</mat-icon>
          </button>
        </div>
      </form>
      <button mat-icon-button aria-label="logout" (click)="logout()">
        <mat-icon>logout</mat-icon>
      </button>
    </mat-toolbar>
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<!-- <div class="router-content login-content" *ngIf="isLoginRoute">
  <router-outlet></router-outlet>
</div> -->